import styled from 'styled-components';

const LabelManageResult = styled.div`
  flex: 1 auto;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .result-content-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-right: 24px;
    gap: 0 48px;
    .content-top-left {
      display: flex;
      flex-direction: row;
      align-items: center;
      flex: 1;
      flex-shrink: 1;
      .top-bcg {
        width: 10px;
        height: 99px;
        background: #1565c0;
        box-shadow: 4px 4px 6px 0px rgba(0, 0, 0, 0.16);
        border-radius: 12px 0 0 12px;
      }
      .top-icon-bcg {
        width: 80px;
        height: 80px;
        /* background: ${(props) => (props.start ? '#616161' : '#1565C0')}; */
        background: ${(props) => (props.start ? '#1565C0' : '#616161')};
        display: flex;
        cursor: pointer;
        .top-icon {
          width: 47px;
          height: 47px;
          align-items: center;
          margin: auto;
        }
        &.top-icon-bcg-disabled {
          background: #616161;
          cursor: not-allowed;
        }
      }
      .top-content-wrap {
        width: 100%;
        background: #ffffff;
        box-shadow: 4px 4px 6px 0px rgba(0, 0, 0, 0.16),
          0px 0px 6px 0px rgba(0, 0, 0, 0.08);
        border-radius: 0 12px 12px 0;
        padding: 16px 22px 16px 18px;
        min-width: 584px;
        .tooltip-wrap {
          display: flex;
          justify-content: space-between;
          .tooltip-wrap-content {
            display: flex;
            flex-direction: row;
            font-size: 24px;
            font-weight: 600;
            color: #212121;
            line-height: 33px;
            height: 33px;
            .tooltip-content {
              margin: -10px 0 0 5px;
            }
          }
        }
        .content-label-info {
          margin-top: 10px;
          display: flex;
          gap: 0 24px;
          .label-box {
            display: flex;
            gap: 0 4px;
            align-items: center;
            .label-box-label {
              padding: 2px 8px;
              height: 24px;
              line-height: 21px;
              background: #f5f5f5;
              border-radius: 12px;
              color: #616161;
              font-size: 14px;
            }
            .label-box-value {
              color: #555555;
              font-size: 14px;
              height: 24px;
              line-height: 23px;
            }
          }
        }
        .content-bottom-list {
          display: flex;
          flex-direction: row;
          align-items: center;
          font-size: 16px;
          font-weight: 400;
          color: #616161;
          line-height: 22px;
          gap: 0 12px;
          .list-like,
          .list-edit,
          .list-download {
            border-right: 1px solid #cccccc;
            padding-right: 12px;
          }
          .list-edit,
          .list-download,
          .list-like {
            display: flex;
            align-items: center;
          }
          .list-regular {
            cursor: pointer;
            display: flex;
            align-items: baseline;
          }
          .list-edit {
            /* padding: 0 35px 0 32px; */
            gap: 6px;
            cursor: pointer;
            &.list-edit-disabled {
              cursor: not-allowed;
            }
            .list-edit-icon {
              cursor: pointer;
              &.list-edit-icon-disabled {
                color: #616161;
                cursor: not-allowed;
              }
            }
          }
          .list-download {
            cursor: pointer;
            gap: 6px;
            &.list-download-disabled {
              cursor: not-allowed;
            }
            .icon {
              &.list-download-disabled {
                cursor: not-allowed;
              }
            }
          }
          .list-like {
            gap: 6px;
            cursor: pointer;
            /* padding-left: 32px; */
            div {
              height: 23px;
            }
          }
        }
      }
    }
    .content-top-right {
      width: 96px;
      height: 88px;
      background: ${(props) =>
        props.calculate && props.start ? '#1565C0' : '#616161'};
      cursor: ${(props) => (props.calculate && props.start ? 'pointer' : '')};
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
      border-radius: 12px;
      justify-content: center;
      display: flex;
      flex-direction: column;
      gap: 4px;
      align-items: center;
      flex-shrink: 0;
      .right-icon {
        width: 35px;
        height: 49px;
      }
      span {
        font-size: 14px;
        font-weight: 400;
        color: ${(props) => (props.calculate ? '#fff' : '#CCCCCC')};
        line-height: 20px;
      }
      &.content-top-right-disabled {
        background: #616161;
        color: #ccc;
        cursor: not-allowed;
      }
    }
  }
  .result-list-wrap {
    background: #ffffff;
    width: 100%;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    margin-top: 24px;
    padding: 8px 32px;
    flex-grow: 1;
    flex: 1 auto;
    .tab-panel-top {
      margin: 48px 0;
      .label-people-num,
      .label-people-date {
        display: flex;
        flex-direction: row;
        .people-date-first {
          min-width: 120px;
        }
      }
      .label-people-num {
        font-size: 32px;
        font-weight: 600;
        color: #212121;
        line-height: 28px;
        span {
          font-size: 16px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.87);
          line-height: 28px;
        }
      }
      .label-people-date {
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.87);
        line-height: 28px;
        align-items: center;
        gap: 4px;
        margin-top: 8px;
        span {
          width: 8px;
          height: 8px;
          background: #1565c0;
          border-radius: 50%;
        }
      }
    }
    .label-history-search {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      gap: 48px;
      padding: 24px 0;
      border-bottom: 1px solid #cccccc;
      .history-search-left {
        flex: 1 auto;
        gap: 48px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
      .search-right {
        display: flex;
        flex-direction: row;
        gap: 16px;
      }
    }
    .label-table-wrap {
      /* max-width: 1000px; */
    }
  }
  .tab-panel {
    width: 100%;
    height: 100%;
    .MuiBox-root {
      height: 100%;
    }
    .panel-charts {
      width: calc(100% - 32px);
      max-width: 1096px;
    }
  }
  .multiple-select {
    margin-top: -18px;
  }
`;

export default LabelManageResult;
